import { render } from "./SpecialPage.vue?vue&type=template&id=7b15cc82&scoped=true&ts=true"
import script from "./SpecialPage.vue?vue&type=script&lang=ts"
export * from "./SpecialPage.vue?vue&type=script&lang=ts"

import "./SpecialPage.vue?vue&type=style&index=0&id=7b15cc82&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b15cc82"]])

export default __exports__